import { SectionPageData } from 'types/content-props/section-page-props';

export const lenkepanelerDataMock: SectionPageData = {
    panelsHeading: 'Hva er din situasjon?',
    panelItems: [
        {
            url: {},
            title: 'Lenke 1',
            ingress: 'Ingress 1',
        },
        {
            url: {},
            title: 'Lenke 2',
            ingress: 'Ingress 2',
        },
        {
            url: {},
            title: 'Lenke 3',
            ingress: 'Ingress 3',
        },
        {
            url: {},
            title: 'Lenke 4',
            ingress: 'Ingress 4',
        },
        {
            url: {},
            title: 'Lenke 5',
            ingress: 'Ingress 5',
        },
    ],
};
